import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dialog", "image"]

    open(event) {
        const row = event.currentTarget.closest("tr")
        this.photos = JSON.parse(row.dataset.feedbackGalleryPhotos)
        this.index = 0
        this.render()
        this.dialogTarget.showModal()
    }

    render() {
        this.imageTarget.src = this.photos[this.index]
    }

    prev() {
        this.index = (this.index - 1 + this.photos.length) % this.photos.length
        this.render()
    }

    next() {
        this.index = (this.index + 1) % this.photos.length
        this.render()
    }

    close() {
        this.dialogTarget.close()
    }

    closeOnBackdrop(event) {
        if (event.target === this.dialogTarget) this.close()
    }
}
